import React from 'react';
import { pathOr } from 'ramda';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { passengersShape, legShape } from 'constants/propTypes';
import TravelInfo from '../JourneySegment/TravelInfo';
import PaxInfo from '../JourneySegment/PaxInfo';
import TravelSummary from '../JourneySegment/TravelSummary';
import { SegmentTotal } from '../JourneyDigest.styles';

import {
  getPaxDetails,
  getAddOnsStationNames,
  filterFaresAddOns,
  overrideCompanionFaresForABSADSAccessibleTravels
} from '../JourneyDigest.utils';

const JourneyDetailsAddOns = ({
  journey,
  passengers,
  direction,
  currency,
  originUIC,
  destinationUIC,
  shouldDisplayAddOnsLegsFirst,
  infantCount,
  isLoyaltyBooking = false
}) => {
  const productsToUse = journey?.addOnLeg ? journey.addOnLeg : journey?.legs?.products;
  const paxDetails = journey && getPaxDetails(passengers, productsToUse, true);
  const addOnItems = pathOr([], ['addOnLeg'], journey);
  const bookingItems = pathOr([], ['bookingItems'], journey);
  const journeyItems = addOnItems.length > 0 ? addOnItems : bookingItems;
  const faresAddOns = filterFaresAddOns(journeyItems);
  const overrideAccesibleTravelPaxTypes = overrideCompanionFaresForABSADSAccessibleTravels(paxDetails, true);

  return (
    <>
      <TravelSummary
        departureDate={journey.date}
        originName={
          shouldDisplayAddOnsLegsFirst
            ? getAddOnsStationNames(direction, originUIC, destinationUIC, shouldDisplayAddOnsLegsFirst)
            : journey.destination.name
        }
        destinationName={shouldDisplayAddOnsLegsFirst ? journey.origin.name : getAddOnsStationNames(direction, originUIC, destinationUIC)}
        paxDetails={paxDetails}
        classOfService={journey?.classOfService}
      />

      <TravelInfo
        departureTime={
          shouldDisplayAddOnsLegsFirst ? (
            <FormattedMessage id="journeyDigest.ABSADSFirstLeg" />
          ) : (
            <FormattedMessage id="journeyDigest.ABSADSSecondLeg" />
          )
        }
        arrivalTime="-"
        origin={{}}
        destination={{}}
        direction={direction}
        fareName={faresAddOns?.[0]?.name}
      />

      <PaxInfo
        paxDetails={paxDetails}
        currency={currency}
        isABSOrAdsAccessibleTravel={overrideAccesibleTravelPaxTypes}
        infantCount={infantCount}
        isLoyaltyBooking={isLoyaltyBooking}
      />

      <SegmentTotal>
        <span data-id="segment-total">
          <FormattedMessage id="journeySummary.segmentTotal" />
          :&nbsp;
          <FormattedCurrency currency={currency} amount={faresAddOns.reduce((acc, pax) => acc + pax?.price, 0)} />
        </span>
      </SegmentTotal>
    </>
  );
};

JourneyDetailsAddOns.propTypes = {
  journey: legShape,
  passengers: passengersShape.isRequired,
  direction: PropTypes.string,
  currency: PropTypes.string,
  originUIC: PropTypes.string,
  destinationUIC: PropTypes.string,
  shouldDisplayAddOnsLegsFirst: PropTypes.bool,
  infantCount: PropTypes.number,
  isLoyaltyBooking: PropTypes.bool
};

export default JourneyDetailsAddOns;
